export const envState = {
  PRODUCTION: 'PRODUCTION',
  DEVELOP: 'DEVELOP',
  HOTFIX: 'HOTFIX',
  RELC: 'RELC',
  BETA: 'BETA',
  LOCAL: 'LOCAL',
};
